// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"195":"2d645ae3a22839fb","203":"488830ca5e46258f","552":"958cbfdfb731875a"}[chunkId] + ".css";
};